module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Value,
      attrs: {
        "label": item.Text,
        "value": item.Value
      }
    }, [_vm._v("\n        " + _vm._s(item.Text) + "\n    ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-512090bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/picklist/src/main.vue
// module id = 601
// module chunks = 15